import * as React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { lightTheme } from './theme'
import { Navigation } from './navigation'
import { LocaleProvider, useTranslations } from 'src/provider/LocaleProvider'
import { Helmet } from 'react-helmet'

function App() {
    const t = useTranslations()

    return (
        <LocaleProvider>
            <Helmet>
                <title>{t('WorldWile.Title') ?? 'Default Title'}</title>
                <meta name="description" content={'dsa'} />
            </Helmet>
            <ThemeProvider theme={lightTheme}>
                <BrowserRouter>
                    <Navigation />
                </BrowserRouter>
            </ThemeProvider>
        </LocaleProvider>
    )
}

export default App
